import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { } from '../../interfaces';
import { SurveyVersion, Style } from '../../models';
import { StyleDataService, SurveyVersionDataService } from '../../services';
import { PVAPage } from '../../components';
import { StyleForm } from './StyleForm';
import { NavLink } from 'react-router-dom';

interface StyleCreateState {
    style: Style;
    surveyVersion: SurveyVersion | undefined;
    defaultValues: any;
}

export class StyleCreate extends React.Component<BaseRouteProps<{ id: number }>, StyleCreateState> {
    private styleDataService = new StyleDataService(this.props.notificationService);
    private surveyVersionDataService = new SurveyVersionDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{ id: number }>) {
        super(props);

        this.state = {
            style: new Style(),
            surveyVersion: undefined,
            defaultValues: {}
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {

        this.surveyVersionDataService.get(this.props.match.params.id).then((surveyVersion: SurveyVersion) => {
            this.setState({
                surveyVersion: surveyVersion
            });
        });

    }

    public render() {

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Buttons>
                        <NavLink to={'/surveyversion/' + this.props.match.params.id + '/styles'}>
                            <span className="glyphicon glyphicon-arrow-left" />
                        </NavLink>
                    </PVAPage.Header.Buttons>
                    <div className="title">Create Style</div>
                </PVAPage.Header>

                <PVAPage.Body>
                    <StyleForm defaultValues={this.state.style} submit={this.save} surveyVersionId={this.props.match.params.id} notificationService={this.props.notificationService} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        if (this.state.surveyVersion === undefined) {
            return;
        }

        values.surveyVersionId = this.state.surveyVersion.id;
        this.styleDataService.create(values).then((success) => {
            if (this.state.surveyVersion === undefined) {
                return;
            }
            this.props.history.push('/surveyversion/' + this.state.surveyVersion.id + '/styles');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/style/StyleCreate.tsx